export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_TOO_SHORT_MESSAGE = `Type at least ${MIN_SEARCH_LENGTH} characters`;
